import React, { useState, useEffect } from 'react'
import '../Css/Home.css'
import '../Css/Mediaquery.css'
import { LuLogOut } from "react-icons/lu";
import { FaEdit } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";
import { HiMenu } from "react-icons/hi";
import { doLogout, getCurrentUserDetail, getDeviceCount, getEnrolledData, isLoggedIn, saveEnroll } from "../Localstorage"
import { NavLink, useNavigate } from 'react-router-dom';
import Bbarna from '../Images/Logo/bbarna.png'
import { useAccessCard } from '../ContextProvider/Accesscardprovider';
import { checkData } from '../Firebase/Course-fb';
import { RiDeleteBin2Fill } from "react-icons/ri";
import { updateDeviceCount } from '../Firebase/User-fb';

const Navbar = ({
    OpenSidebar
}) => {

    const { open, setOpen, accessCard, accessCallReg, logoutUser, toggleProfile, setEnrolData, shouldLogout } = useAccessCard();
    const navigate = useNavigate();

    useEffect(() => {
        if (shouldLogout) {
            navigate("/");
        }
    }, [shouldLogout]);



    return (
        <div className='nav_container'>
            <div className='left_nav'>
                <div className='menu-icon'>
                    <HiMenu className='icon' onClick={OpenSidebar} />
                </div>
                <img src={Bbarna} className='web_logo' />
            </div>
            <div className='right_nav'>
                {isLoggedIn() ? (
                    <div className='right_inner_nav profile' onClick={() => { setOpen(!open) }}>
                        <CgProfile className={`profile-icon ${open ? 'active' : ''}`} />
                    </div>
                ) : (
                    <div className='right_inner_nav btn'>
                        <div className='main_btn' onClick={() => { accessCard(); accessCallReg(); }}>Login</div>
                    </div>
                )}
                <div className={`dropdown ${open ? 'inactive' : 'active'}`}>
                    {isLoggedIn() ? (
                        <h3>{getCurrentUserDetail()[0].name}</h3>
                    ) : null}
                    <ul>
                        <li className='dropdown-item'><NavLink to="/" className="dropdown-link" onClick={() => { toggleProfile(); setOpen(!open); }}><FaEdit className='dropdown-icon' /><span>Edit Profile</span></NavLink></li>
                        <li className='dropdown-item'><NavLink className="dropdown-link" onClick={() => { updateDeviceCount(getDeviceCount(),0); logoutUser() }}><LuLogOut className='dropdown-icon' /><span>Logout</span></NavLink></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Navbar